import * as types from "./mutation-types";
import Vue from "vue";

const vm = new Vue();

export const setData = ({ commit }, payload) => {
  // payload = {prop, value}
  commit(types.SET_DATA, payload);
};

export const clearData = ({ commit }) => {
  commit(types.CLEAR_DATA);
};

export const checkSymbols = ({ dispatch, state }) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(vm.$endpoint.CHECK_ALGO_ORDER_SYMBOLS, {
        params: {
          symbol_1: state.symbol1,
          symbol_2: state.symbol2,
        },
      })
      .then((res) => {
        // console.log(res.data);
        if (state.method === "Fator") {
          dispatch("setData", {
            prop: "currentFactor",
            value: res.data.curr_factor,
          });
        } else if (state.method === "Diferença") {
          dispatch("setData", {
            prop: "currentFactor",
            value: res.data.curr_difference,
          });
        }
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

export const checkSingleSymbol = (
  { dispatch },
  { symbol_number, symbol_name }
) => {
  return new Promise((resolve, reject) => {
    vm.$api
      .get(vm.$endpoint.CHECK_ALGO_ORDER_SYMBOLS, {
        params: {
          symbol_1: symbol_name,
        },
      })
      .then((res) => {
        dispatch("setData", {
          prop: `symbol${symbol_number}Price`,
          value: res.data.symbol_1_info.symbol_1_close,
        });
        dispatch("setData", {
          prop: `symbol${symbol_number}Step`,
          value: res.data.symbol_1_info.symbol_min_volume,
        });
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

export const clearVolumes = ({ commit }, payload) => {
  commit(types.CLEAR_VOLUMES, payload);
};
